import WalletAccountList from './WalletAccountList';
import WalletAccountShow from './WalletAccountShow';

const walletAccounts = {
	list: WalletAccountList,
	show: WalletAccountShow
};

export default walletAccounts;
